const ALLOWED_TAGS = new Set([
  'a',
  'b',
  'blockquote',
  'br',
  'code',
  'del',
  'div',
  'em',
  'figcaption',
  'figure',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'hr',
  'i',
  'img',
  'li',
  'ol',
  'p',
  'pre',
  's',
  'span',
  'strong',
  'sub',
  'sup',
  'table',
  'tbody',
  'td',
  'th',
  'thead',
  'tr',
  'u',
  'ul',
]);

const REMOVE_WITH_CONTENT = new Set([
  'base',
  'button',
  'embed',
  'form',
  'iframe',
  'input',
  'link',
  'meta',
  'object',
  'script',
  'select',
  'style',
  'svg',
  'textarea',
]);

const GLOBAL_ATTRIBUTES = new Set(['title']);
const TAG_ATTRIBUTES = {
  a: new Set(['href', 'target']),
  img: new Set(['alt', 'crossorigin', 'height', 'src', 'title', 'width']),
  td: new Set(['colspan', 'rowspan']),
  th: new Set(['colspan', 'rowspan', 'scope']),
};

function isSafeUrl(value, tagName, attributeName) {
  const normalized = value.trim();
  if (!normalized) return false;

  if (
    normalized.startsWith('/')
    || normalized.startsWith('#')
    || normalized.startsWith('./')
    || normalized.startsWith('../')
  ) {
    return true;
  }

  if (/^https?:\/\//i.test(normalized)) return true;
  return tagName === 'a'
    && attributeName === 'href'
    && /^(mailto|tel):/i.test(normalized);
}

function sanitizeElement(element) {
  const tagName = element.tagName.toLowerCase();

  if (REMOVE_WITH_CONTENT.has(tagName)) {
    element.remove();
    return;
  }

  if (!ALLOWED_TAGS.has(tagName)) {
    element.replaceWith(...element.childNodes);
    return;
  }

  const tagAttributes = TAG_ATTRIBUTES[tagName] || new Set();
  for (const attribute of Array.from(element.attributes)) {
    const attributeName = attribute.name.toLowerCase();
    const isAllowed =
      GLOBAL_ATTRIBUTES.has(attributeName)
      || tagAttributes.has(attributeName);

    if (!isAllowed) {
      element.removeAttribute(attribute.name);
      continue;
    }

    if (
      (attributeName === 'href' || attributeName === 'src')
      && !isSafeUrl(attribute.value, tagName, attributeName)
    ) {
      element.removeAttribute(attribute.name);
    }
  }

  if (tagName === 'a' && element.getAttribute('target') === '_blank') {
    element.setAttribute('rel', 'noopener noreferrer');
  }
}

export function sanitizeRichHtml(value) {
  if (!value || typeof value !== 'string') return '';
  if (typeof DOMParser === 'undefined') return '';

  const document = new DOMParser().parseFromString(value, 'text/html');
  for (const element of Array.from(document.body.querySelectorAll('*'))) {
    sanitizeElement(element);
  }
  return document.body.innerHTML;
}
